var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex wrap-textbox"},[_c('span',{on:{"click":_vm.callMethod}},[_c('BaseIcon',{staticClass:"icon-right-flot",attrs:{"name":_vm.name,"width":_vm.width,"height":_vm.height}})],1),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }